import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import $ from 'jquery';
import axios from 'axios';
import Swal from 'sweetalert2';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { baseurl } from '../utility/helper';

const NewsEventList = () => {
  const [newsEvents, setNewsEvents] = useState([]);
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const initialChapter = roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : "";
  const adminId = sessionStorage.getItem("adminId");
  const tableRef = useRef(null);
  const { id } = useParams();
  const [images, setImages] = useState([]);
  const [formData, setFormData] = useState({});

  const navigate = useNavigate(); // For redirecting after submit

  const fetchEventData = async () => {
    try {
      const token = sessionStorage.getItem("token");
    if (!token) {
      console.error("No authorization token found.");
      return;
    }

    let url = `${baseurl}/admin/eventlist`;

    // if (roleid === 2) {
    //   if (!initialChapter) {
    //     // Check if initialChapter is null or empty
    //     Swal.fire({
    //       icon: 'warning',
    //       title: 'Chapter Missing',
    //       text: 'Please select a chapter before fetching events.',
    //     });
    //     return; // Exit the function if chapter is missing
    //   }
    //   // If needed, you can append chapterId to the URL here
    //   url += `?chapterId=${initialChapter}`; // Uncomment if you need to append chapterId
    // }

    const response = await axios.get(url, {
      headers: {
        'Authorization': `${token}`,
        'Content-Type': 'application/json'
      },
    });


      if (response.data.length > 0) {
        setNewsEvents(response.data); // Store as an array
        console.log(response.data);
      } else {
        setNewsEvents([]); // Set empty array if no data is returned
      }
    } catch (error) {
      console.error("Error fetching event data:", error);
    }
  };


  // Fetch news events from the API
  useEffect(() => {
    fetchEventData();
  }, []);

  // Initialize the DataTable after news events are fetched
  useEffect(() => {
    if (tableRef.current && newsEvents.length > 0) {
      const table = $(tableRef.current);
      if (!table.hasClass('dataTable')) {
        table.DataTable({
          dom: 'Bfrtip',
          buttons: [
            {
              extend: 'copyHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':not(.noExport)', // Exclude action column
                // format: {
                //   body: function (data, row, column, node) {
                //     if ($(node).find('img').length) {
                //       return $(node).find('img').attr('src'); // Copy image URL
                //     }
                //     return data;
                //   },
                // },
              },
            },
            {
              extend: 'excelHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':not(.noExport)', // Exclude action column
                // format: {
                //   body: function (data, row, column, node) {
                //     if ($(node).find('img').length) {
                //       return $(node).find('img').attr('src'); // Extract image URL
                //     }
                //     return data;
                //   },
                // },
              },
            },
            {
              extend: 'csvHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':not(.noExport)', // Exclude action column
                // format: {
                //   body: function (data, row, column, node) {
                //     if ($(node).find('img').length) {
                //       return $(node).find('img').attr('src'); // Export only image URL for CSV
                //     }
                //     return data;
                //   },
                // },
              },
            },
            {
              extend: 'pdfHtml5',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':not(.noExport)', // Exclude action column
                // format: {
                //   body: function (data, row, column, node) {
                //     if ($(node).find('img').length) {
                //       return '[Image]'; // Placeholder text for PDF
                //     }
                //     return data;
                //   },
                // },
              },
              // customize: function (doc) {
              //   let tableBody = doc.content[1].table.body;
          
              //   tableBody.forEach((row, rowIndex) => {
              //     row.forEach((cell, colIndex) => {
              //       if (cell.text === '[Image]') {
              //         let imgElement = document.querySelector(
              //           `table.dataTable tbody tr:nth-child(${rowIndex + 1}) td:nth-child(${colIndex + 1}) img`
              //         );
          
              //         if (imgElement) {
              //           let imgSrc = imgElement.src;
              //           if (imgSrc.startsWith('data:image')) {
              //             tableBody[rowIndex][colIndex] = {
              //               image: imgSrc,
              //               width: 50, // Adjust image width
              //             };
              //           }
              //         }
              //       }
              //     });
              //   });
              // },
            },
            {
              extend: 'print',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':not(.noExport)', // Exclude action column
                // format: {
                //   body: function (data, row, column, node) {
                //     if ($(node).find('img').length) {
                //       return `<img src="${$(node).find('img').attr('src')}" width="50"/>`; // Embed image in print
                //     }
                //     return data;
                //   },
                // },
              },
              // customize: function (win) {
              //   setTimeout(() => {
              //     $(win.document.body)
              //       .find('table')
              //       .find('td')
              //       .each(function () {
              //         if ($(this).text().includes('<img')) {
              //           $(this).html($(this).text()); // Convert text to image
              //         }
              //       });
              //   }, 500);
              // },
            },
            {
              extend: 'colvis',
              className: 'btn btn-primary dttable',
              exportOptions: {
                columns: ':visible',
              },
            },
          ],
          columnDefs: [
            {
              targets: -1, // Assuming Actions column is the last column
              className: "noExport", // Assign class dynamically
              orderable: false, // Disable sorting for actions column
              searchable: false, // Disable searching for actions column
            },
            {
              targets: 0, // Assuming Actions column is the last column
              className: "noExport", // Assign class dynamically
              orderable: false, // Disable sorting for actions column
              searchable: false, // Disable searching for actions column
            },
          ],
          // initComplete: function () {
          //   $($(tableRef.current).find("thead")).prepend(`
          //     <tr>
          //       <th></th> <!-- Empty for column 1 -->
          //       <th colspan="2" style="text-align:center; background-color:#f8f9fa;">
          //         <strong>Mensa Importance</strong>
          //       </th>
          //     </tr>
          //   `);
          // }
           
        });
      }
    }
  }, [newsEvents]);

  

  const handleToggleVisibility = async (id, newStatus) => {
    const token = sessionStorage.getItem("token"); 
    try {
      const response = await fetch(`${baseurl}/admin/news_event/${id}/visibility`, {
        method: "PUT",
        headers: {
        'Authorization': `${token}`, // Pass the token in the Authorization header
        'Content-Type': 'application/json' // Ensure proper content type
        },
        body: JSON.stringify({ visible: newStatus }),
      });

      if (!response.ok) throw new Error("Failed to update visibility");

      setNewsEvents((prev) =>
        prev.map((event) =>
          event.id === id ? { ...event, visible: newStatus } : event
        )
      );
    } catch (error) {
      console.error("Error updating visibility:", error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');  // Ensures day is 2 digits (e.g., '01', '02')
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Month is 0-based, so add 1
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;  // Format: dd-mm-yyyy
  };

  return (
    // <div className="page-wrapper">
    <div className="container mt-4">
      <div className="card p-4 shadow">
        <center><h2 className="mb-4">News Events</h2></center>
        <hr />
        <div className='row'>
          <div style={{ width: '100%', textAlign: '-webkit-right', paddingRight: '37px', fontSize: 'medium' }}>
            <button style={{ border: 'none', padding: '0', margin: '0', cursor: 'pointer' }}>
              <Link to="/admin/Newsevent" style={{ display: 'block', padding: '0.5rem 1rem', textDecoration: 'none', color: 'inherit' }}>
                <i className="bx bxs-plus-circle mr-2"></i>Add New Event
              </Link>
            </button>
          </div>
        </div>
        <br />

        {newsEvents.length > 0 ? (
          <div className="table-responsive">
            <table ref={tableRef} className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Image</th> {/* New Image Column */}
                  <th>Title</th>
                  <th>Short Description</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {newsEvents.map((event) => (
                  <tr key={event.id}>
                    <td class="noExport">
                      {event.main_image ? (
                        <img
                          src={event.main_image}
                          alt={event.title}
                          style={{ width: '60px', height: '60px', objectFit: 'cover', borderRadius: '5px' }}
                        />
                      ) : (
                        <span>No Image</span>
                      )}
                    </td>

                    <td>{event.title}</td>
                    <td>{event.short_desc}</td>
                    <td>{formatDate(event.start_date)}</td>
                    <td>{formatDate(event.end_date)}</td>
                    <td class="noExport">
                    {(roleid === 1 || String(adminId) === String(event.maker_id)) && (
                     <button
                      className={`btn btn-sm ${event.visible ? 'btn-secondary' : 'btn-success'}`}
                      onClick={() => handleToggleVisibility(event.id, !event.visible)}
                      title={event.visible ? 'Hide Event' : 'Show Event'}
                    >
                      {event.visible ? (
                        <>
                          <i className="fas fa-eye-slash"></i>&nbsp;
                        </>
                      ) : (
                        <>
                          <i className="fas fa-eye"></i>&nbsp;
                        </>
                      )}
                    </button>
                    )}
                      &nbsp;&nbsp;

                    {(roleid === 1 || String(adminId) === String(event.maker_id)) && (
                      <button className="btn btn-warning btn-sm me-2 text-black">
                        <Link className="text-black" to={`/admin/Newsevent/${event.id}/edit`}>
                          <i className="fas fa-edit"></i>&nbsp;Edit
                        </Link>
                      </button>
                    )}

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div>No data available, Create new event</div>
        )}
      </div>
    </div>

    // </div>
  );
};

export default NewsEventList;
